// src\components\portal\PerformanceTrendsChart.tsx
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { TrendingUp, Info, Lock } from "lucide-react";

type Props = {
  data: Array<Record<string, number | string>>;
  hasImprovements?: boolean;
};

export default function PerformanceTrendsChart({ data, hasImprovements = false }: Props) {
  return (
    <Card className="relative">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-gray-500">
          <Lock className="h-5 w-5" />
          Andamento performance di accessibilità
          <span className="text-ss bg-gray-100 text-gray-600 px-2 py-1 rounded-full ml-auto">Anteprima</span>
        </CardTitle>
        <CardDescription className="text-gray-400">
          Nel tempo vedrai l'andamento delle tue strutture - funzionalità in arrivo
        </CardDescription>
        <div className="flex items-start gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200">
          <Info className="h-4 w-4 text-gray-500 mt-0.5 flex-shrink-0" />
          <div className="text-s text-gray-600">
            <p className="font-medium">Funzionalità in anteprima</p>
            <p className="text-gray-500 mt-1">
              Questi dati sono simulati. Una volta attivata la funzione di monitoraggio, vedrai qui l'evoluzione reale delle performance di accessibilità.
            </p>
          </div>
        </div>
      </CardHeader>
      <CardContent className="relative">
        {/* Light overlay to indicate locked state - reduced opacity */}
        <div className="absolute inset-0 bg-opacity-20 z-10 rounded-lg pointer-events-none"></div>
        
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" opacity={0.5} />
            <XAxis 
              dataKey="month" 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#9ca3af' }}
            />
            <YAxis 
              domain={[60, 100]}
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#9ca3af' }}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
                opacity: 0.8
              }}
            />
            <Line 
              type="monotone" 
              dataKey="motoria" 
              stroke="#0369a1" 
              strokeWidth={2}
              strokeOpacity={0.6}
              name="Motoria" 
            />
            <Line 
              type="monotone" 
              dataKey="sensoriale" 
              stroke="#ea580c" 
              strokeWidth={2}
              strokeOpacity={0.6}
              name="Sensoriale" 
            />
            <Line 
              type="monotone" 
              dataKey="cognitiva" 
              stroke="#0891b2" 
              strokeWidth={2}
              strokeOpacity={0.6}
              name="Cognitiva" 
            />
            <Line 
              type="monotone" 
              dataKey="alimentare" 
              stroke="#059669" 
              strokeWidth={2}
              strokeOpacity={0.6}
              name="Alimentare" 
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
